<!--
 * 术语引擎选项对话框
 * @author: Mengyu Jin
 * @since: 2023-06-26 15:42:38
-->
<template>
  <el-dialog append-to-body class="component--cat-asset__ate-engines-dialog" :close-on-click-modal="false"
             :visible.sync="visible" title="提取术语" @closed="handleClosed">
    <el-table :data="engines" ref="table" highlight-current-row stripe size="small">
      <el-table-column align="center" label="启用" width="50" class-name="mt-enable-radio">
        <template slot-scope="scope">
          <el-radio :value="selectedEngine.id" :label="scope.row.id"
                    @input="handleSelectionChange(scope.row)" :disabled="isSelectionDisabled(scope.row)">{{
              ""
            }}
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column type="index" label=" "></el-table-column>
      <el-table-column label="AI模型" width="270">
        <template slot-scope="scope">
          <div class="llm__wrapper">
            <img
                :src="scope.row.logoBase64"
                style="height: 24px"
            />
            <span class="llm__name" :title="scope.row.name">{{ scope.row.name }}</span>
            <el-tag
                type="warning"
                size="mini"
                class="ml-3"
                v-if="scope.row.isBeta"
                title="该功能为体验版，如果遇到问题请及时反馈。我们会持续优化提升体验。感谢您的支持！"
            >体验版</el-tag
            >
            <el-tag
                type="success"
                size="mini"
                class="ml-3"
                v-if="scope.row.hasLatestUpdate"
                title="AI模型升级优化，能力全面提升！"
            >有更新</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="150" label="速度">
        <template slot-scope="scope">
          <el-rate
              v-model="scope.row.speedCode"
              :icon-classes="iconClasses"
              void-icon-class="icon-lightning-flash"
              disabled-void-icon-class="icon-lightning-flash"
              disabled
          ></el-rate>
        </template>
      </el-table-column>
      <el-table-column label="说明" property="description" show-overflow-tooltip></el-table-column>
    </el-table>
    <div slot="footer">
      <el-alert type="warning" :closable="false" show-icon v-if="!canAccessAigc">部分模型因AI智慧教学未激活而不可用。</el-alert>
      <el-button plain size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary"
                 @click="confirm">确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import "@/assets/icomoon/style.css";
import {getMonoATEEngines} from "@/api/ATE";

export default {
  data() {
    return {
      selectedEngine: {
        id: "",
        ateEngineId: "",
        isAigc: false
      },
      visible: false,
      engines: [],
      iconClasses: [
        "icon-lightning-flash-1",
        "icon-lightning-flash-1",
        "icon-lightning-flash-1",
      ],
    }
  },
  methods: {
    /**
     *
     * @param {String} ateType 指 MODULE_CODES 的单语或双语术语提取
     * @returns
     */
    async show(ateType) {
      const loading = this.$$loading();
      try {
        const result = await getMonoATEEngines(ateType);
        this.engines = result || [];
      } finally {
        loading.close();
      }
      this.visible = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    isSelectionDisabled(engine) {
      if (!engine.isAigc) return false;
      return !this.canAccessAigc || engine.deprecated;
    },
    handleSelectionChange(row) {
      const {id, engineId, isAigc} = row;
      this.selectedEngine.id = id;
      this.selectedEngine.ateEngineId = engineId;
      this.selectedEngine.isAigc = isAigc;
    },
    handleCancel() {
      this.visible = false;
      this.resolve({
        id: "",
        ateEngineId: ""
      });
    },
    confirm() {
      if (!this.selectedEngine.id) {
        this.$$flash("请选择术语提取模型", "warning");
        return;
      }
      this.visible = false;
      this.resolve(this.selectedEngine);
    },
    handleClosed() {
      this.selectedEngine = {
        id: "",
        ateEngineId: ""
      };
    },
  },
  computed: {
    canAccessAigc() {
      //todo：等待租户权限模块完成
      return true;
    }
  }
}
</script>

<style lang="scss">
.component--cat-asset__ate-engines-dialog {
  .el-dialog {
    width: 900px;
    min-height: auto;

    .el-alert {
      display: inline-flex;
      float: left;
      width: auto;
      height: 32px;

      &__icon {
        font-size: 16px;
        width: 16px;
      }

      &__description {
        display: inline;
        margin: 0;
      }
    }
  }

  .el-table {
    margin-top: 5px;
    border: 1px solid #ebebeb;
    border-bottom-width: 0;

    &__body-wrapper {
      .mt-provider .cell {
        display: flex;
      }

      .llm {
        &__wrapper {
          display: flex;
          min-width: 0;
        }

        &__name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-left: 10px;
        }

        &__status {
          flex-shrink: 0;
        }
      }
    }
  }

  .mt-engine__status_warning {
    background-color: #e6a23c;
    color: white;
  }
}
</style>
